<template>
    <div>
        <item-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter" :setFilter="setFilter"></item-filter-link>
        <item-list-link :listLayout="listLayout" :paginationData="filterSet.page" :itemData="List" :setData="setData"></item-list-link>
        <pagination-link :paginationLayout="paginationLayout" :type="'next'" :paginationData="filterSet.page" :setPage="setPage" :listLength="List.length" :setData="setData"></pagination-link>
    </div>
</template>

<script>
    import VuxAlert from "@/mixins/vux-alert"
    import ItemFilterLink from "@/components/item/ItemFilterLink";
    import ItemListLink from "@/components/item/ItemListLink";
    import PaginationLink from "@/components/item/PaginationLink";
    import itemUtil from "@/components/item/itemUtil";
    import filterMixins from "@/mixins/filterMixins";
    import listMixins from "@/mixins/listMixins";
    import EventBus from "@/utils/event-bus";
    const {filterConfig} = itemUtil;

    export default {
        name: 'ItemListComponent',
        components: {
            ItemFilterLink,
            ItemListLink,
            PaginationLink,
        },
        mixins: [ VuxAlert, filterMixins, listMixins, itemUtil ],
        props: {
            itemType: {},
        },
        data() {
            return{
                listLayout: '',
                filterLayout: '',
                paginationLayout: '',
                paginationType: '',
                listApiParamSet: {},

                searchInput: '',
                searchInputOption: 'su',
                filterDate: ['', ''],

                selectArr: [],
            }
        },
        created() {
            this.initConfig();
            this.setFilterConfig(filterConfig)
            this.setParserType('url', this.$route.fullPath);
        },
        mounted() {
            this.getList(true);
            EventBus.$on('deleteItem', this.deleteItemConfirm)
        },
        beforeDestroy() {
            EventBus.$off('deleteItem')
        },
        computed: {
        },
        methods: {
            initConfig() {
                let itemConfig = this.returnItemConfig(this.itemType);

                this.listLayout = itemConfig.listLayout;
                this.filterLayout = itemConfig.filterLayout;
                this.paginationLayout = itemConfig.paginationLayout;
                this.paginationType = itemConfig.paginationType;
                this.listApiParamSet = itemConfig.listApiParamSet;
                let pageRow = itemConfig.pageRow ? itemConfig.pageRow : 10;
                if(pageRow != this.filterSet.page.size) {
                    this.filterSet.page.size = pageRow;
                }

                let listOptions = {
                    url : this.$api.$item.getItem,
                    defaultParams : this.listApiParamSet,
                }
                this.initList('api', listOptions);
            },
            setData(key, value) {
                this[key] = value;
            },
            deleteItemConfirm() {
                if(this.selectArr.length === 0) {
                    this.errorAlert('1개 이상 선택해주세요.');
                    return false;
                }
                this.createConfirm({
                    title: '',
                    content: '정말 삭제하시겠습니까?',
                    confirmText: '확인',
                    cancelText: '취소',
                    confirm: () => {
                        this.deleteItem();
                    }
                })
            },
            deleteItem() {
                let params = {};
                params.i_idx = [];
                this.selectArr.forEach(item => {
                    params.i_idx.push(item.i_idx);
                })
                try {
                    this.$api.$item.deleteItem(params).then(res => res.Data.Result).then(res => {
                        let returnType = this.deleteReturnType(res.Info.type);
                        if(returnType === true) {
                            this.createAlert({
                                title: '',
                                content: '삭제가 완료되었습니다.',
                                btnText: '확인',
                                hide: () => {
                                    this.getList();
                                }
                            })
                        }
                    })
                }catch (e) {
                    console.log(e);
                }
            },
            deleteReturnType(type) {
                let typeNum = Number(type);
                switch (typeNum) {
                    case 1:
                        return true;
                    case -1:
                        return '삭제에 실패하였습니다. 잠시 후 다시 시도해주세요.';
                    case -3:
                        return '이미 삭제된 아이템입니다.';
                    default:
                        return '삭제에 실패하였습니다. 잠시 후 다시 시도해주세요.';
                }
            },

        }
    }
</script>
